import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@material-ui/core"
import { useSelector } from 'react-redux';
import { DialogResponsive } from './DialogResponsive';
import CloseIcon from '@material-ui/icons/Close'; import { ImagineGrid as Grid } from '../../components'
import { useDispatch } from "react-redux"
import { infraStructureActions } from './../../actions';
import { Select } from './Select';
import { useTranslation } from 'react-i18next';


const useStyle = makeStyles((theme) => ({
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: 'column'

  },
  modalWrapper: {
    padding: "2rem",
    justifySelf: "center"
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  warningIcon: {
    color: "#FE9900",
    fontSize: 100,
  },
  button: {
    width: "100%"
  },
  titleWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    fontWeight: 600,
    font: 'normal normal 600 20px/30px Poppins',
  },
  description: {
    textAlign: "left",
    fontSize: 16
  },
  bodyFooter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}))

export const DialogEditInfra = ({ open, id, type, typeDialog, handleCloseEditInfra, name }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(true)
  const [editedInfra, setEditedInfra] = useState({
    newType: type,
    id,
    newName: name
  })
  const { t } = useTranslation();


  function handleCloseButton() {
    setEditedInfra({
      newType: type,
      id,
      newName: name,
    })

    handleCloseEditInfra()
  }


  function handleYesButton() {
    dispatch(infraStructureActions.editInfraStructure({
      type: editedInfra.newType,
      id: editedInfra.id,
      name: editedInfra.newName
    }));
    handleCloseEditInfra()
  }

  function handleTypeInfra(value) {

    setEditedInfra({
      newType: value,
      id: editedInfra.id,
      newName: editedInfra.newName
    })


  }
  function handleChangeName(value) {

    const timeout = setTimeout(() => {
      setEditedInfra({
        newType: editedInfra.newType,
        id: editedInfra.id,
        newName: value
      })
    }, 500)
    return () => clearTimeout(timeout)
  }


  useEffect(() => {

    if (!!editedInfra.newName && !!editedInfra.newType) {
      setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }, [editedInfra])

  useEffect(() => {
    setEditedInfra({
      newType: type,
      id,
      newName: name,
    })

  }, [id, type, name])

  useEffect(() => {
    setEditedInfra({
      newType: type,
      id,
      newName: name,
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])






  return (
    <DialogResponsive open={open}>
      <DialogContent className={classes.content}>
        <Grid container spacing={4}>

          <Grid item className={classes.titleWrapper}>
            <Typography variant="subtitle1" component="h3" className={classes.title}>
              {t('edicao_de_infraestrutura')}
            </Typography>
            <CloseIcon onClick={handleCloseButton} />
          </Grid>
          <Grid item>
            <p className={classes.description}>{t('realize_a_edicao_dos_dados')}</p>
          </Grid>
        </Grid>



        <Select handle={handleTypeInfra} value={editedInfra.newType} />
        <TextField
          style={{ width: '100%', maxWidth: 500 }}
          variant='filled'
          name="name"
          id="name"
          value={editedInfra.newName}
          label={t('nome_da_infraestrutura')}
          placeholder={t('adicione_o_nome_da_infraestrutura')}
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          onChange={(e) => handleChangeName(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Grid container spacing={4} cols={3}>
          <Grid item>
          </Grid>
          <Grid item>

          </Grid>
          <Grid item>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={handleYesButton}
              disabled={isDisabled}
            >
              {t('salvar_cadastro')}

            </Button>
          </Grid>
        </Grid>
      </DialogActions>

    </DialogResponsive>
  )
}
